import getUrlFromRequest from './getUrlFromRequest';
import getPrefix from './getPrefix';
import getWindowUrl from './getWindowUrl';
import redirectToRoute from './redirectToRoute';

const correctPrefix = ({
  req, res, query, pathname,
}) => {
  const url = req ? getUrlFromRequest(req) : getWindowUrl();
  const prefix = getPrefix(url);

  if (!/\/fr$/.test(prefix)
    && (/\/\/[^/]+\/fr(\/|$)/.test(url) || query.prefix === 'fr')) {
    const { prefix: _, ...queryWithoutPrefix } = query;
    redirectToRoute(pathname, queryWithoutPrefix, res);
  }
};

export default correctPrefix;
